/* eslint-disable eol-last */
import TableHeader from './TableHeader'
import { CardInfo, CardImage, CardJobInfo,
  CardInfoBrief, CardProjectInfo,
  CardPersonnelInfo,
  CardProjectsetting, CardProjectMoneyback,
  CardInfoAudit, CardImageAudit, CardProjectMateriel,
  CardProjectServiceCharge, CardProjectWagestand,
  CardProcessInfo, CardProcessImg,
  CardProjectWages,
  CardApprovalInfo,
  CardProcessMoney,
  CardBriefApprovla,
  CardBriefJoin,
  CardProcessMateriel,
  CardProcessChangeMateriel,
  CardApprovalTime,
  CardScheduleSetting,
  CardProcessChangeProjectMateriel
  // CardProjectWork
} from './CardListInfo'
import MaskModel from './MaskModel'
import Breadcrumb from './Breadcrumb'
import MediaHader from './MediaHader'
import TotaListNum from './TotaListNum'
import NoData from './DataEmpty'
import MapReadyDialog from './BaiduMapDialog/MapReadyDialog.vue'
import Undering from './Undering'
import DrawerBgMask from './DrawerBgMask'

import MobileColFlex from './MobileColFlex'

import AuthorPortrait from './AuthorPortrait/index.vue'
import ApprovalFlow from './ApprovalFlow/index.vue'

import MessageFlex from './MessageFlex/index.vue'
import ApprovalProcess from './ApprovalFlow/process.vue'
import ApprovalSignfor from './ApprovalFlow/signfor.vue'

import { TableRelatedSearch, TableRelatedPagination, TableRSelectCommon } from './CommonTableRelated'
import TencentMap from './TencentMap/index.vue'

import { HdTitle, HdSmartSingle, HdFillBlanks, HdJudge, HdMult, HdSingle } from './addSubject'
import { HdupJudge, HdupMult, HdupSingle } from './updateSubject'
import { SmartSingle, FillBlanks, Judge, Mult, Single, SmartSingleac, FillBlanksac, Judgeac, Multac, Singleac } from './Subject'
import { HdEditor, QuesEditor } from './editor'

const components = [
  TableHeader,
  CardInfo,
  CardImage,
  CardJobInfo,
  MaskModel,
  Breadcrumb,
  CardInfoBrief,
  CardProjectInfo,
  CardPersonnelInfo,
  // CardProjectWork,
  CardProjectsetting,
  CardProjectMoneyback,
  CardInfoAudit,
  CardImageAudit,
  CardProjectMateriel,
  MediaHader,
  CardProjectServiceCharge,
  CardProjectWagestand,
  CardProcessInfo,
  CardProcessImg,
  CardApprovalInfo,
  CardProjectWages,
  TotaListNum,
  NoData,
  CardProcessMoney,
  CardBriefApprovla,
  CardBriefJoin,
  CardProcessMateriel,
  CardProcessChangeMateriel,
  MapReadyDialog,
  Undering,
  DrawerBgMask,
  CardApprovalTime,
  MobileColFlex,
  CardScheduleSetting,
  CardProcessChangeProjectMateriel,
  AuthorPortrait,
  ApprovalFlow,
  MessageFlex,
  TableRelatedSearch,
  TableRelatedPagination,
  ApprovalProcess,
  TableRSelectCommon,
  ApprovalSignfor,
  TencentMap,
  HdTitle, HdSmartSingle, HdFillBlanks, HdJudge, HdMult, HdSingle, HdupJudge, HdupMult, HdupSingle, SmartSingle, FillBlanks, Judge, Mult, Single, SmartSingleac, FillBlanksac, Judgeac, Multac, Singleac,
  HdEditor, QuesEditor
]

const HD_UI = function (Vue, opts = {}) {
  components.map(component => {
    Vue.component(component.name, component)
  })
}

export default HD_UI